export class Login {
  constructor(public username: any, public password: any) {}
}
